import get from "lodash/get";

const stateKey = "notificationTimer";

export const getNotifications = state => get(state, `${stateKey}.notifications`, []);

export const getNotificationCount = state => getNotifications(state).length;
